import {Inject, Injectable, OnDestroy, PLATFORM_ID} from '@angular/core';
import {BotatoWidgetManagerService} from './botato-widget-manager.service';
import {BotatoChatManagerService} from './botato-chat-manager.service';
import {isPlatformBrowser} from '@angular/common';
import {DialogViewModelCreatorService} from './dialog-view-model-creator.service';

/* eslint-disable */

declare let window: { botato: any };

@Injectable({
    providedIn: 'root'
})
export class BotatoAccessorService implements OnDestroy {

    constructor(private widgetManager: BotatoWidgetManagerService,
                private chatManager: BotatoChatManagerService,
                private dialogViewModelCreatorService: DialogViewModelCreatorService,
                @Inject(PLATFORM_ID) private platformId: Object) {

        if (isPlatformBrowser(this.platformId)) {
            window.botato = window.botato || {};
            window.botato.accessor = window.botato.accessor || {};
            window.botato.accessor.openChat = this.openChat.bind(this);
            window.botato.accessor.startChat = this.startChat.bind(this);
            window.botato.accessor.clearAndStartChat = this.clearAndStartChat.bind(this);
            window.botato.accessor.notifyUser = this.notifyUser.bind(this);
        }
    }

    public ngOnDestroy(): void {
        if (isPlatformBrowser(this.platformId)) {
            window.botato.accessor.openChat = undefined;
        }
    }

    public openChat(): void {
        this.widgetManager.openChat();
    }

    public startChat(): void {
        this.chatManager.start();
    }

    public clearAndStartChat(): void {
        this.dialogViewModelCreatorService.clearDialog();
        this.chatManager.start();
    }

    public notifyUser(message: string): void {
        this.widgetManager.notifyUser(message);
    }
}
